
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prototypy-urzadzen-ble",
      function () {
        return require("private-next-pages/prototypy-urzadzen-ble.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prototypy-urzadzen-ble"])
      });
    }
  